var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"message-modal",attrs:{"title":"标题"}},[_vm._v("\n  弹框文本\n  "),_c('vs-button',{on:{"click":function($event){return _vm.$modal('example2')}}},[_vm._v("二级弹框")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }